// extracted by mini-css-extract-plugin
module.exports = {"navbarHeight":"12.26667vw","mainColor":"#F25D24"};